import { z } from 'zod';

export const ElementsCredentialsSchema = z.object({
  clientSecret: z.string(),
  customerSessionClientSecret: z.string(),
  setupIntentId: z.string(),
});

export type ElementsCredentials = z.infer<typeof ElementsCredentialsSchema>;
